import React, {useEffect, useState} from 'react';
import dynamic from 'next/dynamic';
import {MUIBox, MUITypography} from '@/components/MUI-Components';
import {REVIEW_SLIDES} from '@/constants/badges';

const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));

// How long each review platform stays before the slider advances.
const REVIEW_SLIDE_MS = 3500;

// Review-platforms slider (sidebar). Owns its slide index and timer, so each advance re-renders only
// this slider — held by the page, every tick re-rendered the whole post.
const BlogReviewSlider = () => {
    const [reviewSlide, setReviewSlide] = useState(0);

    useEffect(() => {
        const reviewTimer = setInterval(() => setReviewSlide((p) => (p + 1) % REVIEW_SLIDES.length), REVIEW_SLIDE_MS);
        return () => clearInterval(reviewTimer);
    }, []);

    return (
        <MUIBox className="bdn-review-slider">
            <MUITypography className="bdn-slider-label">TRUSTED BY THE PLATFORMS</MUITypography>
            <MUIBox className="bdn-review-track">
                {REVIEW_SLIDES.map((slide, i) => (
                    <MUIBox
                        key={slide.platform}
                        className={`bdn-review-card${reviewSlide === i ? ' bdn-review-card--active' : ''}`}
                        aria-hidden={reviewSlide !== i}
                    >
                        <MUIBox
                            component="a"
                            href={slide.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`View Debut Infotech reviews on ${slide.platform}`}
                            tabIndex={reviewSlide === i ? 0 : -1}
                            className="bdn-review-img-wrap"
                        >
                            <DisplayImage fill src={slide.src} alt={slide.platform} style={{objectFit: 'contain'}} sizes="400px" />
                        </MUIBox>
                    </MUIBox>
                ))}
            </MUIBox>
            <MUIBox className="bdn-slider-dots">
                {REVIEW_SLIDES.map((_, i) => (
                    <button
                        key={i}
                        className={`bdn-dot${reviewSlide === i ? ' bdn-dot--active' : ''}`}
                        onClick={() => setReviewSlide(i)}
                        aria-label={`Review slide ${i + 1}`}
                    />
                ))}
            </MUIBox>
        </MUIBox>
    );
};

export default BlogReviewSlider;
